import React, { useEffect, useState } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { IUserLevel } from "../types/api";
import { useAppDispatch, useAppSelector } from "../hooks/reduxHooks";
import { validateToken } from "../lib/utils";
import { authActions } from "../features/auth/authSlice";
import { validateTokens } from "../lib/api";
import { alertActions } from "../features/alert/alertSlice";

const RequireAuth = ({
    allowedUserLevels,
}: {
    allowedUserLevels: IUserLevel["id"][];
}) => {
    const location = useLocation();
    const { user, loggedIn, token } = useAppSelector(state => state.auth);
    const dispatch = useAppDispatch();
    const [validated, setValidated] = useState<any>();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await validateTokens();
                setValidated(response.status);
            } catch (e) {
                setValidated(e);
            }
        };

        checkAuth();
    }, [location.pathname]);

    if (
        !loggedIn ||
        !user ||
        (!(token && validateToken(token)) && validated !== "success")
    ) {
        dispatch(authActions.logout());
        dispatch(
            alertActions.error({
                persist: true,
                title: "Login session expired",
                text: "Please login again",
            }),
        );
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return allowedUserLevels.includes(user!.userLevel) ? (
        <Outlet />
    ) : (
        <Navigate to="/" state={{ from: location }} replace />
    );
};

export default RequireAuth;
